import { t } from "ttag";

export const SEARCH_DEBOUNCE_DURATION = 300;

export const DEFAULT_SEARCH_LIMIT = 50;

export const NULL_DISPLAY_VALUE = t`(empty)`;
